import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers.js';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsxs("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 24 24', fill: 'none', className: className, children: [_jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 9.75L9.6 12L12 14.25L11.2 15L8 12L11.2 9L12 9.75Z', fill: fillColor }), _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15 9.75L12.6 12L15 14.25L14.2 15L11 12L14.2 9L15 9.75Z', fill: fillColor })] }));
});
export default React.memo(Icon);
